import { render, staticRenderFns } from "./PersonnelUtilizationSummary.vue?vue&type=template&id=231f3384&scoped=true"
import script from "./PersonnelUtilizationSummary.vue?vue&type=script&lang=js"
export * from "./PersonnelUtilizationSummary.vue?vue&type=script&lang=js"
import style0 from "./PersonnelUtilizationSummary.vue?vue&type=style&index=0&id=231f3384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231f3384",
  null
  
)

export default component.exports